<template>
  <div class="app-activation-tariff-detail-modal">
    <b-modal :id="'tariffDetailModal'"
             size="xl"
             data-qa="modal"
             header-bg-variant="custom"
             header-text-variant="custom"
             body-bg-variant="custom"
             body-text-variant="custom"
             footer-bg-variant="custom"
             footer-text-variant="custom"
             v-model="show_"
    >
      <div slot="modal-title" class="detail-box-top">
        <TariffHeading :tariff="tariff">
          <template v-for="slot in possibleChildSlotsFor('Head')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </TariffHeading>
      </div>
      <div slot="default" class="tariff-detail-body">
          <div :class="['tariff-body-left advantage-' + tariff.tariffId]">
            <TariffOverview :tariff="tariff">
              <template v-for="slot in possibleChildSlotsFor('Advantage')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </TariffOverview>
          </div>
        <div class="tariff-body-right">
          <div class="tariff-overview" v-if="isTariffOptions_ === true">
            <div v-if="isVisible" aria-hidden="true" v-b-toggle.collapse-options
                 :class="['tariff-options-btn tariff-options-in tariff-options-btn-' + tariff.tariffId ]">
              Zubuchbare Tarifoptionen
            </div>
            <div v-else aria-hidden="true" v-b-toggle.collapse-options
                 :class="['tariff-options-btn tariff-options-out tariff-options-btn-' + tariff.tariffId]">
              Zubuchbare Tarifoptionen
            </div>
            <b-collapse id="collapse-options" v-model="isVisible">
              <b-card :class="['availible-tariff-options tariff-options-btn-' + tariff.tariffId]">
                <TariffOptionsOverview :tariff="tariff">
                  <template v-for="slot in possibleChildSlotsFor('Options')" v-slot:[`${slot.child}`]>
                    <slot :name="`${slot.parent}`"></slot>
                  </template>
                </TariffOptionsOverview>
              </b-card>
            </b-collapse>
          </div>
          <div class="price-overview">
            <div v-if="isVisiblePrice" aria-hidden="true"  v-b-toggle.collapse-price :class="['tariff-options-btn tariff-options-in tariff-options-btn-' + tariff.tariffId ]">
              <div v-if="isStick_">Installation</div>
              <div v-else>{{tariff.name}} Preisübersicht</div>
            </div>
            <div v-else  aria-hidden="true"  v-b-toggle.collapse-price :class="['tariff-options-btn tariff-options-out tariff-options-btn-' + tariff.tariffId]">
              <div v-if="isStick_">Installation</div>
              <div v-else>{{tariff.name}} Preisübersicht</div>
            </div>
            <b-collapse  id="collapse-price" v-model="isVisiblePrice" class="mt-2">
              <b-card :class="['price-table tariff-options-btn-' + tariff.tariffId]">
                <div v-if="isStick_" v-html="tariff.tariffExtra.installation">
                </div>
            <TariffOverview :tariff="tariff" v-else>
            <template v-for="slot in possibleChildSlotsFor('Price')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
            </TariffOverview>
              </b-card>
            </b-collapse>
          </div>
          </div>
      </div>
      <div slot="modal-footer">
        <div class="row">
          <div class="col-12 col-sm-6 links">
            <div v-if="isProductInformation" class="col-12">
              <a :href="productData" target="_blank">Produktinformationsblatt</a>
            </div>
            <div class="col-12" v-if="isTariffExtra">
              <a :href="tariff.tariffExtra.intenet" target="_blank">Informationsblatt zu Internetzugangsdiensten </a>
            </div>
            <div class="col-12"  v-if="isTariffExtra">
              <a :href="tariff.tariffExtra.price" target="_blank">Länder-und Preistabelle</a>
            </div>
          </div>

          <div class="col-12 col-sm-6 text-right">
            <button :class="'tariff-btn-'+ tariff.tariffId" @click="$emit('select-tariff', tariff)">
              {{tariff.name}} aktivieren
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { BModal } from 'bootstrap-vue'
import { mapGetters, mapMutations } from 'vuex'
import processSteps from '@/mixins/processSteps'
import slotProxy from '@/mixins/slotProxy'
import { stepName } from './Tariff.vue'
import TariffOptionsOverview from '@/components/process/LIDL/Activation/Tariff/TariffOptionsOverview.vue'
import TariffOverview from '@/components/process/LIDL/TariffOverview.vue'
import TariffHeading from '@/components/process/LIDL/Activation/Tariff/TariffHeading.vue'
import sheetLink from '@/mixins/sheetLink'
import syncProperty from '@/mixins/syncProperty'

export default {
  mixins: [
    processSteps(stepName, stepName, stepName),
    syncProperty('show', 'show_'),
    slotProxy(),
    sheetLink
  ],
  data () {
    return {
      isVisible: false,
      isVisiblePrice: false
    }
  },
  components: { TariffHeading, TariffOverview, TariffOptionsOverview, BModal },
  props: {
    tariff: {
      type: Object,
      default: null
    }
  },
  computed: {
    isProductInformation: function () {
      if (this.tariff.productInformation) {
        return this.tariff.productInformation.recentVersion
      }
      return false
    },
    isTariffExtra: function () {
      return this.tariff.tariffExtra
    },
    productData: function () {
      if (this.tariff.productInformation) {
        return this.sheetLink(this.tariff.productInformation.recentVersion)
      } else {
        return '#'
      }
    },
    ...mapGetters('activation/info', [
      'activatableTariffs'
    ]),
    isTariffOptions_: function () {
      return this.tariff?.allTariffOptions?.length > 0
    },
    isStick_: function () {
      return this.isTariffExtra?.stick
    }
  },
  methods: {
    ...mapMutations('activation/tariff', [
      'storeTariff'
    ])
  }
}
</script>
